import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Col, Form, Icon, Row, Upload } from 'antd';
import React from 'react';

const Dragger = Upload.Dragger;

interface IState {
    fileList: any[],
}

interface IProp {
    instruction: string;
    description?: string;
    imageUrl?: string;
    onSubmit: any;
}

export default class UploadDrag extends React.Component<IProp, IState> {

    state = {
        previewVisible: false,
        previewImage: '',
        fileList: [],
    };

    getBase64(img: any, callback: any) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    beforeUpload = (file: any) => {
        let newFileList: any[] = [];
        newFileList.push(file);
        this.setState({ fileList: newFileList });
        return false;
    }

    onRemove = (file: any) => {
        this.setState({ fileList: [] });
        this.props.onSubmit(false, '');
    };

    handleChange = async (info: any) => {
        if (info.file) {
            this.getBase64(info.file, (imageUrl: string) => {
                const imgData = imageUrl.substr(imageUrl.indexOf(',') + 1);
                this.props.onSubmit(true, imgData);
            });
        }

        // this.setState({ fileList })'
    };

    render(): JSX.Element {
        return (
            <div>
                <Form layout="vertical" className="login-form goepik-component-padding">
                    <Row>
                        <Col sm={24} md={24} xl={24}>
                            <Wrapper>
                                <Dragger multiple={false} fileList={this.state.fileList} onChange={this.handleChange} beforeUpload={this.beforeUpload} onRemove={this.onRemove}>
                                    <p className="ant-upload-drag-icon">
                                        <Icon type="inbox" />
                                    </p>
                                    <p className="ant-upload-text">{I18n.l('form.placeholders.photo')}</p>
                                </Dragger>
                            </Wrapper>
                        </Col>
                    </Row>

                </Form>
            </div>
        );
    };
}


const Wrapper = styled.div`
    .ant-upload.ant-upload-drag p.ant-upload-text {
        padding-right: 15px;
        padding-left: 15px;
    }
    .ant-upload-list-item .anticon-cross{
        font-size:23px;
        opacity: 1;
    }
`;
